import React from 'react'
import { useTranslation } from 'react-i18next'

interface PageHeaderProps {
  title: React.ReactNode
  /** Defaults to `common.recruitmentManagement` */
  eyebrow?: string
  description?: string
  className?: string
  titleClassName?: string
  actions?: React.ReactNode
}

export function PageHeader({
  title,
  eyebrow,
  description,
  className = '',
  titleClassName = '',
  actions,
}: PageHeaderProps) {
  const { t } = useTranslation()

  return (
    <header
      className={`flex w-full max-w-full flex-col gap-3 lg:flex-row lg:items-center lg:justify-between ${className}`.trim()}
    >
      <div className="flex min-w-0 flex-col justify-center gap-1.5 lg:shrink-0">
        <p className="text-[11px] font-medium uppercase leading-none tracking-[0.08em] text-muted-foreground">
          {eyebrow ?? t('common.recruitmentManagement')}
        </p>
        <h1
          className={`text-[32px] font-semibold leading-[0.95] text-foreground sm:text-[36px] lg:text-[42px] ${titleClassName}`.trim()}
        >
          {title}
        </h1>
        {description ? (
          <p className="text-sm text-muted-foreground max-[1149px]:text-xs">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex w-full shrink-0 flex-wrap items-center gap-2 lg:w-auto">{actions}</div> : null}
    </header>
  )
}
